import Helper from '../Helper';

const THD_CDN_PREFIX = 'https://images.thdstatic.com/catalog/';

/**
 * Derives a different size variant of a THD CDN image URL.
 * Only works for standard THD image URLs; returns the original URL for others.
 */
export const deriveSizeUrl = (url, currentSize, targetSize) => {
  if (!url?.startsWith(THD_CDN_PREFIX)) { return url; }
  const cur = String(currentSize);
  const target = String(targetSize);
  return url
    .replace(`/${cur}/`, `/${target}/`)
    .replace(`_${cur}.`, `_${target}.`);
};

/**
 * Builds a srcSet string for responsive images from a THD CDN URL.
 * Returns undefined for non-CDN URLs so the attribute is omitted.
 */
export const buildSrcSet = (url, currentSize) => {
  if (!url?.startsWith(THD_CDN_PREFIX)) { return undefined; }
  if (url.includes('<SIZE>') || url.includes('hei=') || url.includes('impolicy=')) { return undefined; }

  const allSizes = [300, 600, 1000];
  return allSizes
    .map((size) => `${deriveSizeUrl(url, currentSize, size)} ${size}w`)
    .join(', ');
};

/** Hero fills the viewport below `sm`, then one column of the two-column PIP layout. */
export const SIZES_HERO = '(max-width: 640px) 100vw, (max-width: 1024px) 50vw, 640px';
export const SIZES_MAIN = '(max-width: 768px) 100vw, 600px';
export const SIZES_TILE = '(max-width: 600px) 100vw, 300px';

/** thd-helmet serializes link attributes into raw HTML, so preload hrefs must be allow-listed. */
const PRELOADABLE_IMAGE_URL = /^https:\/\/(images|assets)\.thdstatic\.com\/[^"'<>\s]*$/;

export const isPreloadableImageUrl = (url) => typeof url === 'string' && PRELOADABLE_IMAGE_URL.test(url);

export const getMediaStillUrl = (media) => {
  if (!media) { return null; }

  if (Helper.isVideo({ media })) {
    return media.videoStill || null;
  }

  if (Helper.isAR({ media })) {
    return media.mediaStill || null;
  }

  if (Helper.isImage360({ media })) {
    return media.url ? `${media.url}?thumb&profile=600` : null;
  }

  return media.url || null;
};

/** note: only THD CDN product images support the derived-size srcSet. */
export const isThdCdnImage = (media) => Helper.isImage({ media }) || Helper.isHotspot({ media });
